import type { FC } from "react";
import { useTranslation } from "@privacy/translations";
import { useForm } from "react-hook-form";
import Typography from "@mui/material/Typography";
import * as FormDialog from "../../shared/FormDialog";

type UnsavedChangesDialogProps = {
  onProceed: () => void;
  onCancel: () => void;
};

export const UnsavedChangesDialog: FC<UnsavedChangesDialogProps> = ({ onCancel, onProceed }) => {
  const { t } = useTranslation();
  const { handleSubmit } = useForm();

  return (
    <FormDialog.Dialog isOpen={true}>
      <FormDialog.Title>{t("DynamicForm.UnsavedChangesDialog.Header")}</FormDialog.Title>
      <FormDialog.Form onSubmit={handleSubmit(onProceed)}>
        <FormDialog.Content>
          <Typography>{t("DynamicForm.UnsavedChangesDialog.Content")}</Typography>
        </FormDialog.Content>
        <FormDialog.ActionButtons>
          <FormDialog.CancelButton onClick={onCancel} />
          <FormDialog.SubmitButton>{t("DynamicForm.UnsavedChangesDialog.ProceedButton")}</FormDialog.SubmitButton>
        </FormDialog.ActionButtons>
      </FormDialog.Form>
    </FormDialog.Dialog>
  );
};
